module.exports = __webpack_public_path__ + "static/media/review-img4.533402ae.png";